
import { isApp } from '../utils/env';

interface Props {
  src: string;
  width?: string;
  height?: string;
}

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '16px',
    },
    height: {
      type: String,
      default: '16px',
    },
  },
  setup(props: Props) {
    return {
      props,
      isApp,
    };
  },
};
